// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { PFixField } from './PFixField.js'
import { DataBuffer } from '../../WebFix/DataBuffer.js'
export let PFixPFSMessageField = function (fieldId, buffer)
{
    this.Value = [];
    PFixField.call(this, fieldId, buffer)
}
PFixPFSMessageField.prototype = Object.create(PFixField.prototype);

PFixPFSMessageField.prototype.ReadValue = function (buffer)
{
    //код мессаги
    let type = buffer.ReadByte();

    //3 или 4 байта - длина
    let lengthBuffer = (type === Message.CODE_XML) ? buffer.ReadBuffer(3) : buffer.ReadBuffer(2);

    let length = 0;
    for (let i = 0; i < lengthBuffer.Length; i++)
        length += lengthBuffer.ReadByte() << 8 * i;
    lengthBuffer.Reset();

    let message = new byte[length + lengthBuffer.Length + 1];
    message[0] = type;
    buffer.ReadBytes(lengthBuffer.Length, message, 0);
    //for (int i = 0; i < lengthBuffer.Length; i++)
    //    message[1 + i] = lengthBuffer.ReadByte();

    //читаем мессагу
    let offset = lengthBuffer.Length + 1;
    buffer.ReadBytes(length, message, offset);
    //for (int i = 0; i < length; i++)
    //    message[offset + i] = buffer.ReadByte();

    this.Value = message;
}

PFixPFSMessageField.prototype.Write = function (buffer)
{
    buffer.Write(this.FieldId);
    let db = new DataBuffer(this.Value);
    buffer.Write(db);
}